import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const PageHero = ({ label, title, highlight, subtitle, image }) => (
  <section className="relative h-[62vh] min-h-[420px] w-full overflow-hidden bg-[#111111] flex items-end" data-testid="page-hero">
    <img src={image} alt={`${title} — Prospera Staffing Dubai`} className="absolute inset-0 w-full h-full object-cover hero-kenburns" />
    <div className="absolute inset-0 bg-[#0b0b0b]/68" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#111111] via-[#111111]/20 to-transparent" />

    <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-8 pb-14">
      <nav className="flex items-center gap-2 text-white/55 text-xs font-body mb-6" aria-label="Breadcrumb">
        <Link to="/" className="hover:text-white transition-colors">Home</Link>
        <ChevronRight size={13} />
        <span className="text-[#E03535]">{label}</span>
      </nav>
      <h1 className="hero-fade font-display text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-4xl" style={{ animationDelay: "0.05s" }}>
        {title} {highlight && <span className="text-[#E03535]">{highlight}</span>}
      </h1>
      {subtitle && (
        <p className="hero-fade font-body text-white/70 text-lg mt-6 max-w-2xl leading-relaxed" style={{ animationDelay: "0.18s" }}>
          {subtitle}
        </p>
      )}
    </div>
  </section>
);

export default PageHero;
